export default (url) => {
  const urlPrefix = url.split(':')[0]

  return urlPrefix === 'https' || urlPrefix === 'http'
}
